export const CANCELED_CODE = 'ERR_CANCELED'
